import { render, staticRenderFns } from "./SchoolOutline.vue?vue&type=template&id=68a3bfb6&"
import script from "./SchoolOutline.vue?vue&type=script&lang=js&"
export * from "./SchoolOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports